var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMute(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 10,
    viewBox: "0 0 12 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.03906 0.1875L2.95312 2.25H0.5625C0.234375 2.25 0 2.50781 0 2.8125V6.1875C0 6.51562 0.234375 6.75 0.5625 6.75H2.95312L5.03906 8.83594C5.39062 9.1875 6 8.95312 6 8.4375V0.585938C6 0.0703125 5.39062 -0.164062 5.03906 0.1875ZM10.8047 4.5L11.8828 3.44531C12.0234 3.30469 12.0234 3.04688 11.8828 2.90625L11.3438 2.36719C11.2031 2.22656 10.9453 2.22656 10.8047 2.36719L9.75 3.44531L8.67188 2.36719C8.53125 2.22656 8.27344 2.22656 8.13281 2.36719L7.59375 2.90625C7.45312 3.04688 7.45312 3.30469 7.59375 3.44531L8.67188 4.5L7.59375 5.57812C7.45312 5.71875 7.45312 5.97656 7.59375 6.11719L8.13281 6.65625C8.27344 6.79688 8.53125 6.79688 8.67188 6.65625L9.75 5.57812L10.8047 6.65625C10.9453 6.79688 11.2031 6.79688 11.3438 6.65625L11.8828 6.11719C12.0234 5.97656 12.0234 5.71875 11.8828 5.57812L10.8047 4.5Z",
    fill: "#C1C4CC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMute);
export default __webpack_public_path__ + "static/media/mute.b2e3d4f3.svg";
export { ForwardRef as ReactComponent };